import { RestError } from '@azure/core-http';
import { OrderDto } from '@groundfloor-platform/mgmt-service-g-sdk';
import { useImmer } from 'use-immer';
import { castDraft } from 'immer';
import { useMutationUndoCancellation } from '../../order-details.queries';

export interface UndoCancellationActionProps {
  order: OrderDto;
  onAbort(): void;
  onSuccess(): void;
}

export interface UndoCancellationActionState {
  error?: RestError;
  loading: boolean;
}

export interface UndoCancellationActionHandlers {
  onCancelIntent(): void;
  onConfirmUndo(): void;
}

const initialState: UndoCancellationActionState = {
  loading: false
};

export function useUndoCancellationAction({ onAbort, onSuccess, order }: UndoCancellationActionProps) {
  const [state, setState] = useImmer(initialState);
  const undoCancellationMutation = useMutationUndoCancellation();

  const handlers: UndoCancellationActionHandlers = {
    onCancelIntent() {
      onAbort();
    },
    onConfirmUndo() {
      setState((draft) => {
        draft.loading = true;
      });
      undoCancellationMutation.mutate(
        { retailerID: order.retailer.id, orderID: order.id },
        {
          onSuccess() {
            onSuccess();
          },
          onError(error) {
            setState((draft) => {
              draft.loading = false;
              draft.error = castDraft(error);
            });
          }
        }
      );
    }
  };

  return [state, handlers] as const;
}
